module.exports = __webpack_public_path__ + "static/media/6.10_preview.4f6ac47e.png";